<template>
  <div>
    <div class="home bg-primary">          
      <nna-container :spacing="30" height-auto>      
      <nna-search-destination />      
      </nna-container>    
    </div>
    <nna-container v-if="isAuthenticated" :spacing="40" height-auto>
      <nna-checkin />
    </nna-container>
    <nna-container height-auto>
      <!--<nna-filter-shops />-->
      <h2 class="md-title md-title--sub text-align-left">I tuoi Shop</h2>
      <nna-shops-list />
    </nna-container>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import nnaShopsList from '@/modules/common/components/list/Shops'
import nnaCheckin from '@/modules/common/components/checkin/Checkin'
import nnaFilterShops from '@/modules/common/components/checkin/FilterShops'
import nnaSearchDestination from '@/modules/common/components/searchDestination/SearchDestination'
export default {
  name: 'Auth',
  components: {
    nnaShopsList,
    nnaCheckin,
    nnaFilterShops,
    nnaSearchDestination
  },
  methods: {
    ...mapActions({
      getNotices: 'notices/getNotices',
    }),
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },  
  data() {
    return {
      initial: 'Initial Value',
      type: null,
      withLabel: null,
      inline: null,
      number: null,
      textarea: null,
      autogrow: null,
      disabled: null
    }
  },
  mounted() {
    this.getNotices()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/home/pages/Home.vue